// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".page-title[data-v-ea1e5d4c] {\n  max-width: 500px;\n  margin: 0 auto;\n}\n.top-title[data-v-ea1e5d4c] {\n  letter-spacing: -0.3px;\n  font-size: 16px;\n}", ""]);
// Exports
module.exports = exports;
